import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { tv } from 'tailwind-variants';

import { Icon } from '@/components/ui/icon.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

interface EntityCommentSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  icon?: IconDefinition;
  classNameIcon?: string;
  removeHr?: boolean;
}

const entityCommentSectionStyles = tv({
  slots: {
    container: ['my-6'],
    icon: ['text-blue-600 text-lg mr-2 transition-transform duration-300 w-6 h-7'],
  },
});

export function EntityCommentSection({ title, icon, classNameIcon, removeHr, ...props }: EntityCommentSectionProps) {
  const { container, icon: iconStyle } = entityCommentSectionStyles();

  const { className, ...rest } = props;

  return (
    <>
      <section className={container({ className })} {...rest}>
        <div className="flex items-start">
          {icon && (
            <div className="flex items-center">
              <Icon icon={icon} className={iconStyle({ className: classNameIcon })} />
            </div>
          )}
          <div>
            <Typography variant={TypographyVariant.BODY_STRONG} className="mb-1">{title}</Typography>
          </div>
        </div>

        <div>{props.children}</div>
      </section>
      {!removeHr && <hr />}
    </>
  );
}
